interface TimeZoneConfig {
    [key: string]: string;
}

const TIME_ZONE_MAP: TimeZoneConfig = {
    'UTC': 'UTC',
    'KST': 'Asia/Seoul',
    'JST': 'Asia/Tokyo',
    'EST': 'America/New_York',
    'PST': 'America/Los_Angeles',
};

/**
 * 주어진 시간문자열과 시간대를 기반으로 새로운 시간대의 시간을 반환합니다
 * @param timeString - ISO 형식의 시간 문자열 (예: '2024-12-11T14:13:31.259Z')
 * @param targetTimezone - 변환하고자 하는 목표 시간대 (예: 'KST', 'UTC')
 * @param sourceTimezone - 원본 시간의 시간대 (기본값: 'UTC')
 * @returns 변환된 시간 문자열
 * @throws Error - 잘못된 시간대나 시간 형식이 입력된 경우
 */
export function convertTimezone(
    timeString: any,
    targetTimezone: string,
    sourceTimezone: string = 'UTC'
): string {
    // 입력값 검증
    if (!TIME_ZONE_MAP[targetTimezone]) {
        throw new Error(`지원하지 않는 목표 시간대입니다: ${targetTimezone}`);
    }
    if (!TIME_ZONE_MAP[sourceTimezone]) {
        throw new Error(`지원하지 않는 원본 시간대입니다: ${sourceTimezone}`);
    }
    if(timeString === null)
        return '-'

    try {
        // 시간 객체 생성
        const date = new Date(timeString);
        if (isNaN(date.getTime())) {
            throw new Error('잘못된 시간 형식입니다');
        }

        // 시간대 변환
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: TIME_ZONE_MAP[targetTimezone],
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            fractionalSecondDigits: 3,
            hour12: false
        }).format(date);
    } catch (error) {
        // @ts-ignore
        throw new Error(`시간 변환 중 오류가 발생했습니다: ${error.message}`);
    }
}